import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function usePaymentUrlFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = useCallback(
    (key: string, fallback = "") => searchParams.get(key) ?? fallback,
    [searchParams],
  );

  const getNumber = useCallback(
    (key: string, fallback: number) => {
      const value = searchParams.get(key);
      if (!value) return fallback;
      const parsed = Number(value);
      return Number.isNaN(parsed) ? fallback : parsed;
    },
    [searchParams],
  );

  const getBoolean = useCallback(
    (key: string, fallback = false) => {
      const value = searchParams.get(key);
      if (value === null) return fallback;
      return value === "true" || value === "1";
    },
    [searchParams],
  );

  const updateParams = useCallback(
    (
      updates: Record<string, string | number | boolean | null | undefined>,
      replace = true,
    ) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          Object.entries(updates).forEach(([key, value]) => {
            if (
              value === null ||
              value === undefined ||
              value === "" ||
              value === false
            ) {
              next.delete(key);
            } else {
              next.set(key, String(value));
            }
          });
          return next;
        },
        { replace },
      );
    },
    [setSearchParams],
  );

  return { searchParams, get, getNumber, getBoolean, updateParams };
}
